var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`formulate-input-element formulate-input-element--${_vm.context.type}`,attrs:{"data-type":_vm.context.type}},[_c('RadioButton',{attrs:{"options":_vm.context.options},model:{value:(_vm.context.model),callback:function ($$v) {_vm.$set(_vm.context, "model", $$v)},expression:"context.model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }